import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiselectPillListFn = /* @__PURE__ */ createRecipe('multiselect-pill-list', {}, [])

const multiselectPillListVariantMap = {}

const multiselectPillListVariantKeys = Object.keys(multiselectPillListVariantMap)

export const multiselectPillList = /* @__PURE__ */ Object.assign(memo(multiselectPillListFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiselectPillList',
  __getCompoundVariantCss__: multiselectPillListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiselectPillListVariantKeys,
  variantMap: multiselectPillListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiselectPillListVariantKeys)
  },
  getVariantProps: multiselectPillListFn.getVariantProps,
})